import React from 'react';

import { AutoUpgradeAvoidDeactivationBanner as AutoUpgradeAvoidDeactivationBannerComponent } from '@atlassian/auto-upgrade-not-a-trial';
import { RelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

export const AutoUpgradeAvoidDeactivationBanner = ({ cloudId }: { cloudId: string }) => {
	return (
		<RelayEnvironmentProvider>
			<AutoUpgradeAvoidDeactivationBannerComponent baseProduct="confluence" cloudId={cloudId} />
		</RelayEnvironmentProvider>
	);
};
